import { abbrNumberFilter } from "app/filters/ngFilters";

const commonFormatNumber = abbrNumberFilter();

/**
 * Formatter from abbrNumberFilter rounds the number between 0 and 1 (0, 0.2, 0.4, 0.8, 1) to 0 and 1,
 * which is not acceptable for graph yAxis as it became (0, 0, 0, 1, 1).
 */
export const formatNumber = (value: number): number | string => {
    if (value < 1000) {
        return value;
    }

    return commonFormatNumber(value);
};
